import React from "react"

const RunnApp = React.lazy(() => import("~/containers/RunnApp"))

export default RunnApp
